import { BlobData } from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface BlobDataParams {
  containerName: string;
  path: string;
}

const endPoint = 'inspection/image';

export const getBlobData = async (
  params: BlobDataParams,
): Promise<BlobData[]> => {
  const queryParams = new URLSearchParams();
  queryParams.append('containerName', params.containerName);
  queryParams.append('path', params.path);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
